import React, { useState } from 'react';
import SearchField from '../Util/SearchField';

interface Props {
  search?: string;
  onSearchChange: (val: string) => void;
}

const UsersFilter: React.FunctionComponent<Props> = (props) => {

  const [search, setSearch] = useState<string>();

  return (
   <div>
      <SearchField key="search" value={search} onChange={(ev) => {
        setSearch(ev);
        props.onSearchChange(ev)
        }} />
    </div>
  );
};

export default UsersFilter;
